import { h, Component } from 'preact';
import * as THREE from 'three';

export default class Stars extends Component {

	constructor(props) {
		super(props);

		this.props = props;
		const { scene, imageRoot, windowWidth } = props;
		this.scene = scene;
		this.imageRoot = imageRoot;
		this.stars = [[[], [], [], [], [], []], [[], [], [], [], [], []], [[], [], [], [], [], []], [[], [], [], [], [], []], [[], [], [], [], [], []]]; // fix
		this.windowWidth = windowWidth;
		this.windowRatio = window.innerWidth / window.innerHeight;
		this.dustRandomNum = [];
		this.numOfDust = 600;	
		
		this.createStars = this.createStars.bind(this);
		this.updateStars = this.updateStars.bind(this);
		
		this.starsInfo = [
			{
				yPos: 3.2,
				xPosOffset: 0.6,
				speed: 0.2,
				arcAmplitude: 0.15,
				waveAmplitude: 0.07,
				waveFrequency: 50,
				widthRatio: 0.6,
			},
			{
				yPos: 2.4,
				xPosOffset: 0.8,
				speed: 0.2,
				arcAmplitude: 0.1,
				waveAmplitude: 0.07,
				waveFrequency: 50,
				widthRatio: 0.7,
			},
			{
				yPos: 1.5,
				xPosOffset: 0.2,
				speed: 0.2,
				arcAmplitude: 0.2,
				waveAmplitude: 0.07,
				waveFrequency: 50,
				widthRatio: 0.6,
			},
			{
				yPos: 1,
				xPosOffset: 0.4,
				speed: 0.2,
				arcAmplitude: 0.1,
				waveAmplitude: 0.07,
				waveFrequency: 50,
				widthRatio: 0.7,
			},
			{
				yPos: 0.2,
				xPosOffset: 0,
				speed: 0.2,
				arcAmplitude: 0.2,
				waveAmplitude: 0.07,
				waveFrequency: 50,
				widthRatio: 0.6,
			},
		];
	}

	async init() {
		const texture = await this.loadTexture(`${this.imageRoot}/up/cr0d5v.webp`);
		this.createStars(texture);
	}

	loadTexture(url) {
		return new Promise((resolve, reject) => {
			new THREE.TextureLoader().load(url, resolve, undefined, reject);
		});
	}

	createStars(texture) {  
		//stars
		const numOfStars = 5;
		const starGroup = new THREE.Group();
		starGroup.rotation.set(0, 0, -Math.PI / 15);
		this.scene.add(starGroup);
		for (let s = 0; s < numOfStars; s++) { //star
			const numOfTrails = 6;
			for (let t = 0; t < numOfTrails; t++) { //trail
				let numOfParticles = t == 0 ? t == 5 ? this.numOfDust : 600 : t < 3 ? 150 : 75;
				for (let p = 0; p < numOfParticles; p++) { //particle
					const particleGeo = new THREE.PlaneGeometry(1, 1, 1);
					const isStar = p == 0 && t == 0;
					const pR = p / numOfParticles; // particle ratio

					//const color = isStar ? new THREE.Color(1, 1, 1) : new THREE.Color(s % 2 ? 1 - pR : pR, s % 2 ? pR : 1 - pR, 1); 
					const color = isStar ? new THREE.Color(1, 1, 1) : new THREE.Color(pR, 1 - pR, 1); 

					const particleMat = new THREE.MeshStandardMaterial({
						color: color,
						map: texture,
						emissive: color,
						emissiveIntensity: isStar ? 10 : 1,
						transparent: true,
						opacity: t == 5 ? 1 : t == 0 ? 1 - (pR) : t < 3 ? (1 - (pR)) / 4 : (1 - (pR)) / 2,
					});

					const particle = new THREE.Mesh(particleGeo, particleMat);

					particle.name = 'shootingStar' + s;

					let scale = isStar ? 0.2 : t == 0 ? 0.1 : t == 5 ? Math.random() * 0.1 : t < 3 ? 0.2 : 0.02 - (pR * 0.0);
					scale = scale / 3;
					particle.scale.set(isStar ? scale * 2 : scale, scale, scale);
					particle.visible = false;

					this.stars[s][t].push(particle);
					starGroup.add(particle);
				}
			}
		}

		for (let i = 0; i < this.numOfDust; i++) {
			this.dustRandomNum.push(Math.random());
		}
		
	}

	updateStars(elapsedTime) {
		//stars
		this.stars.forEach((star, s) => { //star
			star.forEach((trail, t) => { //trail
				trail.forEach((particle, p) => { //particle
					const { yPos, xPosOffset, speed, widthRatio, arcAmplitude, waveFrequency, waveAmplitude } = this.starsInfo[s];
					const distance = 3; // -1 to 2
					const startPos = -1; 
					const time = ((((elapsedTime * speed) + (xPosOffset * distance))) % distance) + startPos;
					const length = this.windowWidth * widthRatio; 
					const particleRatio = p / trail.length; //particle ratio
					const c = time - particleRatio; //particle position offset
					const arcPos = Math.cos(c) * (length * arcAmplitude);
					const waveOffset = t == 2 || t == 4 ? (Math.PI / 3) : 0; // offset trail wave position for trail 2 & 4
					const wavePos = t > 0 ? (Math.cos((c + (waveOffset)) * (waveFrequency)) * particleRatio * (waveAmplitude * this.windowRatio)) : 0; //first Trail doesn't have wave
				
					/// IMPROVE DUST CODE
					const gravity = (((elapsedTime / 6) + this.dustRandomNum[p]) % 0.2);
					const dustY = ((arcPos + yPos) + (p % 2 ? gravity : -gravity));
					const dustX = ((c * length) - (gravity * (8 * this.windowRatio)));
				
					if (t == 5) {
						particle.material.opacity = 1 - (gravity / 0.2);
					}

					particle.position.set( t == 5 ? dustX : c * length, t == 5 ? dustY : arcPos + wavePos + yPos, 0);
					particle.visible = true;
				});
			});
		});
	}

	resize(windowWidth) {
		this.windowRatio = window.innerWidth / window.innerHeight;
		this.windowWidth = windowWidth;

		this.stars.forEach((star, s) => { //star
			star.forEach((trail, t) => { //trail
				trail.forEach((particle, p) => { //particle
					if (t > 0 && t < 3) {
						let scale = (0.2 / 3) * this.windowRatio;
						particle.scale.set(scale, scale, scale);
					}
				});
			});
		});
	}
}